<template>
  <div>
    <div class="f7">
      <div class="title">{{htmlData.Title}}</div>
      <div class="date">{{dateFormat('mm-dd', new Date(htmlData.CreateTime))}}创建</div>
    </div>
    <div class="container">
      <div class="content" v-html="htmlData.Detail"></div>
    </div>
  </div>
</template>

<script>
import { getDynamicDetail } from "@/request/api.js";

export default {
  // props:["html"]
  created() {
    let params = { dynamicID: this.$route.query.dID };
    let that = this;
    getDynamicDetail(params).then(res => {
      console.log(res);
      if (res.statusText == "OK") {
        that.htmlData = res.data;
        console.log(that.htmlStr, res, "qwew");
      }
    });
  },
  data() {
    return {
      htmlStr: "",
      htmlData: null
    };
  },
  methods: {
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    }
  }
};
</script>
<style lang="less" scoped>
.f7 {
  background-color: #344f97;
  padding: 30px;
  .title {
    text-align: center;
    font-size: 26px;
    color: #ffffff;
  }
  .date {
    font-size: 14px;
    line-height: 22px;
    color: #ffffff;
    text-align: center;
  }
}
.container {
  width: 1200px;
  margin: 0 auto;

  .content {
    padding: 20px;
    min-height: 700px;
  }
}
</style>
